<template>
  <Select size="small" style="width:100px;" v-model="currency">
    <Option :value="item" v-for="item in items" :key="item">
      {{ item }}
    </Option>
  </Select>
</template>

<script>
import startAndend from "./startAndend.vue";
export default {
  components: { startAndend },
  props: ["bbb",],
  model: {
    prop: "bbb",
    event: "aaa",
  },
  data() {
    return {
      items: this.lydic.getA("mType"),
      currency:''
    };
  },
  methods: {
    tt() {
      this.currency = this.bbb;
    },
  },
  mounted() {
    this.tt();
  },
  watch:{
    currency(v){
      this.$emit('aaa',v)
    },
    bbb(v){
      this.tt();
    }
  },
  
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia/currency.vue